
import cookieUtil from '@/library/cookieUtil';
import userAgentHelper from "@/library/userAgentHelper";
import qs from 'qs';
import api from '@/api/';
import store from '@/store/';

let initPre = {
  mgRenterPre () {
    try {
      if (userAgentHelper.browser === userAgentHelper.BrowserEnum.MGRenter) {
        cookieUtil.delCookie('mogo_default');
      }
    }
    catch (e) {
      console.log(e)
    }
  },
  expirePre() {
    try {
      let tempMogoDefault = cookieUtil.getCookie('mogo_default', true);
      if (tempMogoDefault && tempMogoDefault.timestamp) {
        let tempTimeStamp = new Date().valueOf();
        if ((tempTimeStamp - tempMogoDefault.timestamp) > 1000 * 60 * 60 * 12 * 1) {
          cookieUtil.delCookie('mogo_default')
        }
      } else {
        cookieUtil.delCookie('mogo_default');
      }
    }
    catch (e) {
      console.log(e)
    }
  },
  redirectPre() {
    try {

      let tempQuery = qs.parse(window.location.href.split('?')[1]);
      if (((tempQuery.code && tempQuery.code.length > 0) || (tempQuery.auth_code && tempQuery.auth_code.length > 0)) && window.location.pathname == "/find") {
        window.history.replaceState({}, "", `/my/${location.search}`);
      }
      // 是第三方回调并且有存储origin  存储的域名和当前域名不一致
      window.isRealAuthState = /mgzf.com$/.test(tempQuery.state);
      if (window.isRealAuthState && location.origin != tempQuery.state) {
        window.redirectPre = true;
        window.location.replace(`${tempQuery.state}${location.pathname}${location.search}`);
      }
      if (window.isRealAuthState) {
        delete tempQuery.state;
        window.history.replaceState({}, "", `${location.pathname}?${qs.stringify(tempQuery)}`);
      }

    } catch (e) {
      console.log(e)
    }
  },
  paramFillPre() {
    if (window.location.href.indexOf('mogo_default') > -1) {
      try {
        let query = qs.parse(window.location.href.split('?')[1]);
        let tempMogoDefault = query.mogo_default;
        delete query.mogo_default;
        let queryStr = qs.stringify(query);
        if (queryStr) {
          window.history.replaceState({}, "", window.location.href.split('?')[0] + "?" + queryStr);
        } else {
          window.history.replaceState({}, "", window.location.href.split('?')[0]);
        }
        let mogoDefault = JSON.parse(tempMogoDefault)
        mogoDefault.timestamp = new Date().valueOf();
        cookieUtil.setCookie('mogo_default', mogoDefault)
      }
      catch (ex) {
        console.log(ex)
      }
    }
  },
  bindPre() {
    try {
      let tempMogoDefault = cookieUtil.getCookie('mogo_default', true);
      // 登陆状态微信内查询用户是否绑定微信支付宝(排除支付宝小程序)
      if (tempMogoDefault && tempMogoDefault.userId && !userAgentHelper.isAliMini() && !userAgentHelper.isWxMini()
        && (userAgentHelper.browser === userAgentHelper.BrowserEnum.ALI || userAgentHelper.browser === userAgentHelper.BrowserEnum.WEI_XIN)) {
        api.authorize
          .findUserWxBindByUserId({
            userId: tempMogoDefault.userId,
            bindSrc: (userAgentHelper.browser === userAgentHelper.BrowserEnum.WEI_XIN ? 2 : 3)
          })
          .then(response => {
            let res = response.data;
            if (res.code != "10000") {
              cookieUtil.delCookie('mogo_default')
              store.dispatch('resetAuth');
            }
          });
      }
    }
    catch (e) {
      console.log(e)
    }
  }
}

initPre.mgRenterPre();
initPre.expirePre();
initPre.redirectPre();
initPre.paramFillPre();
initPre.bindPre();








// WEBPACK FOOTER //
// ./src/store/modules/authorizeHelper/initPre.js